import OutlookHome from "modules/outlook/Home.jsx";

import NewProjectCommunicationOutlook from "modules/project/communications/outlook/new";
import NewProjectCommunicationOutlookOutgoing from "modules/project/communications/outlook/new_outgoing";
import NewCustomFormRecordsOutlook from "modules/custom_form/records/outlook/new";
import NewStoreRequestOutlook from "modules/store/requests/outlook/new";
import CaptureStoreRequestOutlook from "modules/store/requests/outlook/capture";

let routes = [
  { path: "/custom_form/:custom_form_id/records/new", component: NewCustomFormRecordsOutlook, name: "New CustomFormRecord" },
  { path: "/project/communications/new_outgoing", component: NewProjectCommunicationOutlookOutgoing, name: "New Project Communication Outgoing" },
  { path: "/project/communications/new", component: NewProjectCommunicationOutlook, name: "New Project Communication" },
  { path: "/store/requests/new", component: NewStoreRequestOutlook, name: "New Store Request" },
  { path: "/store/requests/capture", component: CaptureStoreRequestOutlook, name: "Store Request Capture" },
  { path: "/", component: OutlookHome, name: "Outlook Home" },
];

export default routes;
